import $ from 'jquery';

export const toggleViewDetails = ($el) => {
    var $target = $($el.data('target')),
        activeClassName = 'products-data-table__view-extra-info--active';

    $el.toggleClass(activeClassName);
    if ($el.hasClass(activeClassName)) {
        $target.slideDown(200);
        $el.text('Hide Details');
    } else {
        $target.slideUp(200);
        $el.text('View Details');
    }
};

export const binds = () => {
    // ---------------- update input on data table
    $('#wrapper').on(
        'click.product',
        '[data-toggle="product-detail"]',
        function(event) {
            toggleViewDetails($(this));
        }
    );
};
